<template>
  <div class="mt__main">
    <div class="mt__banner">
      <!-- <el-carousel height="280px" arrow="never" indicator-position="none">
        <el-carousel-item>
          <img src="../assets/about/carousel0.png">
        </el-carousel-item>
      </el-carousel>-->
    </div>
    <div class="mt__center">
      <div class="mt__content--main">
        <div>
          <el-tabs
            @tab-click="tabClick"
            v-model="activeName"
            tab-position="left"
            :class="{'mt__sticky':sticky}"
          >
            <el-tab-pane label="公司介绍" name="introduction"></el-tab-pane>
            <el-tab-pane label="企业团队" name="team"></el-tab-pane>
            <el-tab-pane label="荣誉资质" name="certificate"></el-tab-pane>
            <el-tab-pane label="大事记" name="memorabilia"></el-tab-pane>
            <el-tab-pane label="客户分布" name="customers"></el-tab-pane>
          </el-tabs>
        </div>
        <div>
          <div id="introduction">
            <h1>公司介绍</h1>
            <img
              src="../assets/about/introduction.png"
              style="margin-left: 45px;"
              class="mt__content--right"
            >
            <p>深圳市名通科技股份有限公司成立于2006年，属于信息技术领域高科技企业，注册资金3000万元。公司秉承“为客户创造价值，和客户一起成功”的核心理念，专业致力于网络运维/运营支撑、大数据分析产品的技术开发及相关技术服务。</p>
            <p>公司总部位于深圳，是深圳市重点软件企业，公司拥有计算机信息系统集成三级资质，并通过了ISO9001质量管理体系认证、ISO27001信息安全管理体系认证和CMMI3认证，获得了发明专利、软件著作权54项。公司业务涵盖中国移动、中国联通、中国电信三大通信运营商，公司商用客户遍布广东、北京、上海、山东、江苏、陕西、湖南、湖北、江西、广西等全国28省，是行业业务区域最广的企业之一。</p>
            <p>公司始终致力于自主知识产权系统开发和平台建设，为运营商网络测评、网络优化、网络规划和网络运维提供专业的网络质量分析和智能优化服务。同时，公司在通信网络大数据挖掘、高精度用户位置定位已建立起独有的技术优势，构建的网络大数据位置平台，基于用户位置、运动轨迹、通信行为开展公共安全、智能交通、智慧旅游、市场营销、商业选址等全行业大数据应用，成为业内网络位置大数据新技术新应用的引领者。</p>
          </div>
          <hr>
          <div id="team">
            <h1>企业团队</h1>
            <el-card
              class="mt__card mt__content--right"
              :body-style="{ padding: '30px' }"
              shadow="never"
            >
              <div class="mt__card--text">
                <h1>骨干</h1>
                <span>公司骨干在华为、中兴、移动等大型通信企业工作经历，在通信支撑系统的研发和运营方面有丰富的经验。</span>
              </div>
              <div class="mt__card--img">
                <img src="../assets/about/backbone.png">
              </div>
            </el-card>
            <el-card class="mt__card" :body-style="{ padding: '30px' }" shadow="never">
              <div class="mt__card--text">
                <h1>员工</h1>
                <span>公司现有400人，90%以上具有本科学历，20%以上具有硕士学历，骨干普遍毕业于清华大学、北京邮电大学、西安电子科技大学等著名高等院校。</span>
              </div>
              <div class="mt__card--img">
                <ve-ring :data="chartData" :extend="chartExtend" :settings="chartSettings"></ve-ring>
              </div>
            </el-card>
          </div>
          <hr>
          <div id="certificate">
            <el-button type="text" class="mt__content--right" @click="moreCertificate = true">
              查看更多<i class="el-icon-arrow-right"></i>
            </el-button>

            <el-dialog title="荣誉资质" :visible.sync="moreCertificate" width="950px" top="5vh">
              <img src="../assets/about/certificate2.jpg">
              <img src="../assets/about/certificate3.jpg">
              <img src="../assets/about/certificate0.jpg">
              <img src="../assets/about/certificate1.jpg">
              <img src="../assets/about/certificate4.jpg">
              <img src="../assets/about/certificate5.jpg">
              <img src="../assets/about/certificate6.jpg">
            </el-dialog>

            <h1>荣誉资质</h1>

            <div class="mt__content--right">
              <el-card :body-style="{ padding: '0' }">
                <el-carousel
                  height="280px"
                  style="width:420px;"
                  arrow="never"
                >
                  <el-carousel-item>
                    <img src="../assets/about/minicertificate0.jpg">
                  </el-carousel-item>
                  <el-carousel-item>
                    <img src="../assets/about/minicertificate1.jpg">
                  </el-carousel-item>
                  <el-carousel-item>
                    <img src="../assets/about/minicertificate2.jpg">
                  </el-carousel-item>
                  <el-carousel-item>
                    <img src="../assets/about/minicertificate3.jpg">
                  </el-carousel-item>
                  <el-carousel-item>
                    <img src="../assets/about/minicertificate4.jpg">
                  </el-carousel-item>
                  <el-carousel-item>
                    <img src="../assets/about/minicertificate5.jpg">
                  </el-carousel-item>
                  <el-carousel-item>
                    <img src="../assets/about/minicertificate6.jpg">
                  </el-carousel-item>
                </el-carousel>
              </el-card>
            </div>
            <div class="mt__ul">
              <div class="mt__li"></div>获得信息系统集成及服务资质证书三级
              <br>
              <div class="mt__li"></div>获得CMMI证书3级
              <br>
              <div class="mt__li"></div>获得软件企业认定证书
              <br>
              <div class="mt__li"></div>获得国家高新技术企业证书
              <br>
              <div class="mt__li"></div>获得质量管理体系认证证书（ISO9001）
              <br>
              <div class="mt__li"></div>获得环境管理体系认证证书（ISO14001）
              <br>
              <div class="mt__li"></div>获得信息安全管理体系认证证书（ISO27001）
              <br>
              <div class="mt__li"></div>获得信息技术服务管理体系认证证书
              <br>
              <div class="mt__li"></div>获得职业健康安全管理体系认证证书
              <br>
            </div>
          </div>
          <hr>
          <div id="memorabilia">
            <el-button type="text" class="mt__content--right" @click="moreMemorabilia = true">
              查看更多<i class="el-icon-arrow-right"></i>
            </el-button>

            <h1>大事记</h1>
            <el-dialog title="大事记" :visible.sync="moreMemorabilia" width="1200px" top="5vh">
              <div class="mt__content--table">
                <template v-for="item in memorabilia">
                  <div class="mt__content--main">
                    <div>
                      <span style="font-size:28px;color:#1A1A1A;">{{item['时间描述']}}</span>
                    </div>
                    <div style="padding-top:3px;">
                      <p>{{item['描述']}}</p>
                    </div>
                  </div>
                  <div class="mt__content--main">
                    <div style="padding-left:30px;">
                      <img src="../assets/about/memorabilia.png">
                      <img src="../assets/about/oldmemorabilia.png">
                    </div>
                    <div style="vertical-align: middle;">
                      <hr>
                    </div>
                  </div>
                </template>
              </div>
            </el-dialog>
            <div>
              <div class="mt__content--table">
                <template v-for="item in recentMemorabilia">
                  <div class="mt__content--main">
                    <div style="width:70px;vertical-align: middle;">
                      <span style="font-size:22px;color:#333333;">{{item['时间描述']}}</span>
                    </div>
                    <div style="text-align: left;">
                      <span>{{item['描述']}}</span>
                    </div>
                  </div>
                  <div class="mt__content--main">
                    <div style="padding-left:25px;">
                      <img src="../assets/about/memorabiliaMini.png">
                      <img src="../assets/about/oldmemorabiliaMini.png">
                    </div>
                    <div style></div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <hr>
          <div id="customers">
            <h1>客户分布</h1>
            <p>我们与移动、电信、联通长期稳定合作，服务范围覆盖全国。</p>
            <br>
            <!-- <div class="mt__content--table">
              <div class="mt__content--main">
                <img src="../assets/about/customers.png">
                <div style="vertical-align: middle;width:300px;">
                  <div>
                    <img src="../assets/about/province.png">
                    <span>省级覆盖项目</span>
                  </div>
                  <div>
                    <img src="../assets/about/city.png">
                    <span>地市覆盖项目</span>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tabs from "./tabs.vue";
import employees from "../assets/about/employees.png";

export default {
  extends: tabs,
  name: "about",
  data() {
    return {
      tabName: "about",
      moreCertificate: false,
      moreMemorabilia: false,
      memorabilia: [],
      recentMemorabilia: [],
      chartSettings: {
        radius: [60, 100],
        offsetY: 120
      },
      chartExtend: {
        graphic: [
          {
            type: "image",
            style: {
              image: employees
            },
            left: 161,
            top: 82
          },
          {
            type: "text",
            style: {
              fill: "#5B7384",
              text: "400",
              font: "bold 24px 'Microsoft YaHei'"
            },
            cursor: "auto",
            left: 161,
            top: 134
          }
        ],
        color: ["#81CF34", "#FF8533", "#0B87E6"],
        legend: { show: false },
        series: {
          label: {
            formatter: "{degree|{b}} {percentage|{d}%}",
            rich: {
              degree: {
                color: "#4D4D4D"
              },
              percentage: {
                fontSize: 20
              }
            }
          }
          // tooltip:{
          //   formatter:
          // }
        }
      },
      chartData: {
        columns: ["学历", "人数"],
        rows: [
          { 学历: "硕士", 人数: 80 },
          { 学历: "博士", 人数: 16 },
          { 学历: "本科", 人数: 304 }
        ]
      },
      // team: {
      //   bachelor: 76,
      //   master: 20,
      //   doctor: 4
      // },
      scrollTop: {
        introduction: 0,
        team: 0,
        certificate: 0,
        memorabilia: 0,
        customers: 0
      }
    };
  },
  // watch: {
  //   // 如果 `scrollTop` 发生改变，这个函数就会运行
  //   scrollTop: function(newQuestion, oldQuestion) {
  //     console.log(123);
  //   }
  // },
  created() {},
  mounted() {
    let that = this;
    this.$http
      .post("/mtex/mtplat/portal/queryEvents")
      .then(function(response) {
        that.memorabilia = response.data.result.data;
        that.recentMemorabilia = that.memorabilia.slice(0, 5);
      })
      .catch(function(err) {
        console.log(err);
      });
  },
  updated() {},
  methods: {}
};
</script>
<style scoped>
.mt__banner {
  background-image: url("../assets/about/carousel0.png");
}
.mt__center > .mt__content--main > div:last-child {
  padding: 0 40px;
}

.mt__card {
  width: 430px;
  height: 460px;
}
.mt__card--text {
  margin: -20px 20px 35px 20px;
}
.mt__card--text h1 {
  text-align: center;
}
.mt__card--img {
  text-align: center;
}

.mt__ul {
  font-size: 14px;
  line-height: 32px;
  color: #4d4d4d;
}
.mt__li {
  width: 4px;
  height: 4px;
  display: inline-block;
  background-color: #4d4d4d;
  border-radius: 50%;
  margin-right: 6px;
  vertical-align: middle;
}
#memorabilia .mt__content--main:nth-child(2) img:last-child {
  display: none;
}
#memorabilia .mt__content--main:not(:nth-child(2)) img:first-child {
  display: none;
}
span {
  color: #4d4d4d;
}

#memorabilia .mt__content--main > div:first-child {
  width: 110px;
  text-align: left;
}
#memorabilia .mt__content--table > .mt__content--main:first-child p {
  font-size: 20px;
  font-weight: bolder;
}
#memorabilia
  .mt__content--table
  > .mt__content--main:first-child
  div:last-child
  span {
  font-size: 16px;
  line-height: 16px;
  color: #333333;
}

#memorabilia p {
  margin-top: 0;
}
#memorabilia hr {
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/about.vue